/**
 * Game template definitions — hardcoded, not DB entities.
 * Each template describes a game type that can be assigned to a team.
 */

export const GAME_TEMPLATES = [
  {
    id: 'chat-visual-novel',
    name: 'Chat-Based Visual Novel',
    description: 'A phone-simulator chat game styled like a messenger app. Characters appear as contacts; dialogue flows through chat bubbles.',
    icon: 'MessageCircle',
    defaultAspect: '9:16'
  }
];

/**
 * Screen aspect-ratio presets for testing games across devices.
 * Portrait-only — games are designed for vertical phone screens.
 */
export const SCREEN_PRESETS = [
  { id: '9:16',   label: '9:16',   w: 9,  h: 16,   group: 'Portrait', device: 'Phone' },
  { id: '9:19.5', label: '9:19.5', w: 9,  h: 19.5, group: 'Portrait', device: 'Tall Phone' },
  { id: '9:20',   label: '9:20',   w: 9,  h: 20,   group: 'Portrait', device: 'Modern Phone' },
  { id: '3:4',    label: '3:4',    w: 3,  h: 4,    group: 'Portrait', device: 'Tablet' },
];

export function getTemplate(id) {
  return GAME_TEMPLATES.find((t) => t.id === id) || null;
}
